export default __webpack_public_path__ + "static/media/slide4.1fa81210.jpg";